module.exports = __webpack_public_path__ + "img/joinGroup.024bf11a.svg";